<ion-toolbar>

  <ion-buttons slot="start">
    <ion-button
      (click)="onCancel()"
      color="secondary"
      fill="outline"
      >
      <ion-icon name="arrow-back" />
      <span class="hidden-md">&nbsp; {{ 'ACTION.back' | translate }}</span>
    </ion-button>
  </ion-buttons>

  <ion-title role="heading" aria-level="2">{{ 'TITLE.groupStop' | translate }}</ion-title>

</ion-toolbar>

<ion-content class="ion-padding">

  @for (data of routeEvents; track routeEventTrackBy($index)) {
    <route-event-card [data]="data" [preview]="true" />
  }

</ion-content>

<ion-toolbar class="bottom-actions">
  <ion-button type="button" fill="outline" expand="block" (click)="onCancel()">
    {{ 'ACTION.close' | translate }}
  </ion-button>
</ion-toolbar>
